import React from 'react'
import { ImageGrid } from '@/components/ImageGrid'
import { isEmpty } from '@/utils/nunchee-kit/isEmpty'
interface ISubFooterProps {
  setSubFooterProps?: any
  globalSubFooterProps?: any
}

export const SubFooter: React.FC<ISubFooterProps> = (props) => {
  const { setSubFooterProps, globalSubFooterProps } = props

  const subfooter = setSubFooterProps || globalSubFooterProps || {}

  if (!subfooter || isEmpty(subfooter)) {
    return null
  }

  return <ImageGrid data={subfooter} />
}
